import { render, staticRenderFns } from "./GcpProjects.vue?vue&type=template&id=2e147dde&"
import script from "./GcpProjects.vue?vue&type=script&lang=js&"
export * from "./GcpProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports